import React, { Component } from 'react'
import { FULLSTORY_HELPDOC_URL } from 'constants/HelpDocConstants'

class FullStory extends Component {
  render() {
    return (
      <div>
        <p>FullStory Customer? Drift will automatically detect FullStory on your site
          and FullStory session URLs will begin appearing inside of Drift. It’s like
          magic.
        </p>
        <p>Want more information? <a href={FULLSTORY_HELPDOC_URL} target="_blank">Learn More.</a></p>
        <p>
          <a href="https://help.drift.com/article/fullstory-integration/" target="_blank">Learn more about integrating with FullStory</a>
        </p>
      </div>
    )
  }
}

export default FullStory



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/FullStory.js